export const EDUCACAO_INFANTIL_BEBES = 0;
export const EDUCACAO_INFANTIL_CRIANCAS_BEM_PEQUENAS_MATERNAL = 1;
export const EDUCACAO_INFANTIL_CRIANCAS_BEM_PEQUENAS_PRE_ESCOLA = 2;

export const EDUCACAO_FUNDAMENTAL_UM = 3;
export const EDUCACAO_FUNDAMENTAL_DOIS = 4;
export const EDUCACAO_FUNDAMENTAL_TRES = 5;
export const EDUCACAO_FUNDAMENTAL_QUATRO = 6;
export const EDUCACAO_FUNDAMENTAL_CINCO = 7;
export const EDUCACAO_FUNDAMENTAL_SEIS = 8;
export const EDUCACAO_FUNDAMENTAL_SETE = 9;
export const EDUCACAO_FUNDAMENTAL_OITO = 10;
export const EDUCACAO_FUNDAMENTAL_NOVE = 11;

export const EDUCACAO_ENSINO_MEDIO_UM = 12;
export const EDUCACAO_ENSINO_MEDIO_DOIS = 13;
export const EDUCACAO_ENSINO_MEDIO_TRES = 14;

const allEtapasEnsino = [];
allEtapasEnsino[EDUCACAO_INFANTIL_BEBES] = {
  name: 'Educação infantil – bebês (berçário)',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_INFANTIL_CRIANCAS_BEM_PEQUENAS_MATERNAL] = {
  name: 'Educação infantil – crianças bem pequenas (maternal)',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_INFANTIL_CRIANCAS_BEM_PEQUENAS_PRE_ESCOLA] = {
  name: 'Educação infantil – crianças pequenas (pré-escola)',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_FUNDAMENTAL_UM] = {
  name: '1º ano EF',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_FUNDAMENTAL_DOIS] = {
  name: '2º ano EF',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_FUNDAMENTAL_TRES] = {
  name: '3º ano EF',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_FUNDAMENTAL_QUATRO] = {
  name: '4º ano EF',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_FUNDAMENTAL_CINCO] = {
  name: '5º ano EF',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_FUNDAMENTAL_SEIS] = {
  name: '6º ano EF',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_FUNDAMENTAL_SETE] = {
  name: '7º ano EF',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_FUNDAMENTAL_OITO] = {
  name: '8º ano EF',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_FUNDAMENTAL_NOVE] = {
  name: '9º ano EF',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_ENSINO_MEDIO_UM] = {
  name: '1º ano EM',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_ENSINO_MEDIO_DOIS] = {
  name: '2º ano EM',
  icon: {
    name: 'file-alt',
  },
};

allEtapasEnsino[EDUCACAO_ENSINO_MEDIO_TRES] = {
  name: '3º ano EM',
  icon: {
    name: 'file-alt',
  },
};

function getName(index) {
  if (index < allEtapasEnsino.length) {
    return allEtapasEnsino[index].name;
  }
  return null;
}

function getIcon(index) {
  if (index < allEtapasEnsino.length) {
    return allEtapasEnsino[index].icon;
  }
  return null;
}

export { allEtapasEnsino, getName, getIcon };
